import dashboard from "../../assets/icons/dashboard.png";
import beneficiary from "../../assets/icons/beneficiary.png";
import sendMoney from "../../assets/icons/sendmoney.png";
import transaction from "../../assets/icons/transaction.png";
import pending from "../../assets/icons/pending.png";
import wallet from "../../assets/icons/wallet.png";
import bank from "../../assets/icons/bank.png";
import report from "../../assets/icons/report.png";
import help from "../../assets/icons/help.png";
// The ARM financial wordmark. Used in both sidebar states, collapsed it is
// scaled to the rail rather than swapped for a cut-out glyph, which did not
// read as the brand on its own. (The sidebar previously showed AmiLogo.png,
// a generic green starburst that is not ARMF branding at all.)
import brandLogo from "../../assets/images/armf-logo.png";
import setting from "../../assets/icons/setting.png";
import { useLocation, useNavigate } from "react-router-dom";
import { Tooltip } from "antd";
import { FiLogOut, FiShield, FiChevronsLeft, FiChevronsRight, FiFileText } from "react-icons/fi";
import { CreditCardIcon, ConvertIcon } from "../svg-organizer/SvgOrganizer";
import { goToLogout } from "../../api/client";
import { useAuth } from "../../api/useAuth";

const Sidebar = ({ isExpanded = true, closeButton = false, onToggle }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { user } = useAuth();

  const sideBarOptions = [
    {
      icon: <img src={dashboard} alt="" width={20} height={20} className="sidebar-img" />,
      name: "Dashboard",
      link: "/dashboard",
      moreLinks: ["/"],
    },
    {
      icon: <img src={beneficiary} alt="" width={20} height={20} className="sidebar-img" />,
      name: "Beneficiary",
      link: "/recipient",
      moreLinks: ["/add-recipient"],
    },
    {
      icon: <img src={sendMoney} alt="" width={20} height={20} className="sidebar-img" />,
      name: "Send Money",
      link: "/new-transfer",
      moreLinks: [],
    },
    {
      icon: <img src={transaction} alt="" width={20} height={20} className="sidebar-img" />,
      name: "Transaction",
      link: "/my-transaction",
      moreLinks: [],
    },
    {
      icon: <img src={pending} alt="" width={20} height={20} className="sidebar-img" />,
      name: "Pending Transaction",
      link: "/pending-transactions",
      moreLinks: [],
    },
    {
      icon: <img src={wallet} alt="" width={20} height={20} className="sidebar-img" />,
      name: "Mobile Wallet",
      link: "/wallet",
      moreLinks: [],
      comingSoon: true,
    },
    {
      icon: <img src={bank} alt="" width={20} height={20} className="sidebar-img" />,
      name: "Bank Account",
      link: "/my-account",
      moreLinks: ["/connect-new-account"],
    },
    {
      icon: <ConvertIcon color="currentColor" />,
      name: "Convert",
      link: "/convert",
      moreLinks: [],
    },
    {
      icon: <img src={report} alt="" width={20} height={20} className="sidebar-img" />,
      name: "Report",
      link: "/reports",
      moreLinks: ["/statement"],
    },
    {
      icon: <FiFileText size={20} />,
      name: "Invoice",
      link: "/invoice-generator",
      moreLinks: [
        "/invoice-flow/create",
        "/invoice-flow/review",
        "/invoice-flow/created",
        "/invoice-created",
      ],
      comingSoon: true,
    },
    {
      icon: <CreditCardIcon color="currentColor" />,
      name: "Card",
      link: "/card",
      moreLinks: [
        "/card-summary",
        "/create-new-card",
        "/create-company-card",
        "/create-company-card2",
      ],
      comingSoon: true,
    },
  ];

  const bottomOptions = [
    user?.isAdmin && {
      icon: <FiShield size={20} />,
      name: "Admin Panel",
      link: "/admin",
      moreLinks: ["/admin/transactions", "/admin/settings"],
    },
    {
      icon: <img src={setting} alt="" width={20} height={20} className="sidebar-img" />,
      name: "Settings",
      link: "/settings",
      moreLinks: [],
    },
    {
      icon: <img src={help} alt="" width={20} height={20} className="sidebar-img" />,
      name: "Help Center",
      link: "/help",
      moreLinks: [],
    },
  ].filter(Boolean);

  const isActive = (link, moreLinks = []) =>
    link === location.pathname || moreLinks.includes(location.pathname);

  const go = (item) => {
    if (item.comingSoon) return;
    navigate(item.link);
  };

  const renderItem = (item) => {
    const active = isActive(item.link, item.moreLinks);
    const content = (
      <button
        key={item.name}
        type="button"
        className={`sidebar-nav-item ${active ? "active" : "unactive"}`}
        onClick={() => go(item)}
        disabled={item.comingSoon}
        aria-label={item.name}
      >
        <span className="sidebar-nav-icon">{item.icon}</span>
        {isExpanded && <span className="sidebar-nav-label">{item.name}</span>}
        {isExpanded && item.comingSoon && (
          <span
            style={{
              marginLeft: "auto",
              fontSize: 10,
              fontWeight: 600,
              color: "#1bbb6b",
              background: "#e8f9f1",
              borderRadius: 999,
              padding: "2px 8px",
              letterSpacing: "0.04em",
              textTransform: "uppercase",
            }}
          >
            Soon
          </span>
        )}
      </button>
    );

    if (isExpanded) return content;
    return (
      <Tooltip
        key={item.name}
        title={item.comingSoon ? `${item.name} (Coming soon)` : item.name}
        placement="right"
      >
        {content}
      </Tooltip>
    );
  };

  return (
    <aside className={`app-sidebar-shell ${isExpanded ? "is-expanded" : "is-collapsed"}`}>
      <div className="sidebar-top">
        <div className="sidebar-brand">
          <button
            type="button"
            className="sidebar-brand-button"
            onClick={() => navigate("/dashboard")}
            aria-label="Go to dashboard"
          >
            {/* The real ARM financial wordmark when there is room for it, the
                icon mark when collapsed. It was showing the 36px icon plus
                hand-typed "ARMfinancial" text instead of the brand asset. */}
            {/* The same wordmark in both states, collapsed it is simply
                scaled to the rail. The cut-out f alone did not read as the
                brand. */}
            <img
              src={brandLogo}
              alt="ARM financial"
              className={isExpanded ? "sidebar-logo-full" : "sidebar-logo-mark"}
            />
          </button>

          {/* Collapse control. The sidebar used to expand or collapse purely
              on which page you were on, with no way to override it. */}
          {onToggle && (
            <button
              type="button"
              className="sidebar-collapse-toggle"
              onClick={onToggle}
              aria-label={isExpanded ? "Collapse sidebar" : "Expand sidebar"}
              aria-expanded={isExpanded}
              title={isExpanded ? "Collapse sidebar" : "Expand sidebar"}
            >
              {isExpanded ? <FiChevronsLeft size={18} /> : <FiChevronsRight size={18} />}
            </button>
          )}
          {closeButton && (
            <button
              type="button"
              className="sidebar-mobile-close"
              data-bs-dismiss="offcanvas"
              aria-label="Close"
            >
              x
            </button>
          )}
        </div>

        <nav className="sidebar-nav" aria-label="Primary">
          {sideBarOptions.map(renderItem)}
        </nav>
      </div>

      <div className="sidebar-footer">
        {bottomOptions.map(renderItem)}
        <button
          type="button"
          className={`sidebar-nav-item sidebar-logout ${isExpanded ? "" : "sidebar-icon-only"}`}
          onClick={goToLogout}
          aria-label="Logout"
        >
          <span className="sidebar-nav-icon">
            <FiLogOut size={20} />
          </span>
          {isExpanded && <span className="sidebar-nav-label">Logout</span>}
        </button>
      </div>
    </aside>
  );
};

export default Sidebar;
